import game2048 from 'templates/game2048/Game2048Layout';

export default game2048;
